export const MediaAttachmentUnsimplifier = {
  MAPPING: {
    i: 'id',
    t: 'type',
    u: 'url',
    pu: 'preview_url',
    smp4: 'source_mp4',
    m: 'meta',
    ai: 'account_id',
    su: 'status_url',
    si: 'status_id',
    mli: 'marketplace_listing_id',
    fn: 'file_name',
    d: 'description',
    b: 'blurhash',
    fct: 'file_content_type',
    ff: 'file_fingerprint',
  },

  META_MAPPING: {
    a: 'aspect',
    ab: 'audio_bitrate',
    ac: 'audio_channels',
    ae: 'audio_encode',
    d: 'duration',
    f: 'fps',
    h: 'height',
    l: 'length',
    lr: 'lowres',
    o: 'original',
    p: 'playable',
    s: 'size',
    sm: 'small',
    w: 'width'
  },

  INNER_META_PARENT_KEYS: ['lowres', 'original', 'playable', 'small'],

  INNER_META_MAPPING: {
    w: 'width',
    h: 'height',
    fr: 'frame_rate',
    d: 'duration',
    b: 'bitrate',
    s: 'size',
    a: 'aspect'
  },

  unsimplifyKey(simplifiedKey, mapping) {
    return mapping[simplifiedKey] || simplifiedKey;
  },

  unsimplify(data) {
    if (Array.isArray(data)) {
      return data.map(this.unsimplifyObject.bind(this));
    } else {
      return this.unsimplifyObject(data);
    }
  },

  unsimplifyObject(obj) {
    const newObj = {};
    for (const key in obj) {
      const unsimplifiedKey = this.unsimplifyKey(key, this.MAPPING);
      if (unsimplifiedKey === 'meta') {
        newObj[unsimplifiedKey] = this.unsimplifyMeta(obj[key]);
      } else {
        newObj[unsimplifiedKey] = obj[key];
      }
    }
    return newObj;
  },

  unsimplifyMeta(metaObj) {
    const newMetaObj = {};
    for (const key in metaObj) {
      const unsimplifiedKey = this.unsimplifyKey(key, this.META_MAPPING);
      
      if (this.INNER_META_PARENT_KEYS.includes(unsimplifiedKey)) {
        newMetaObj[unsimplifiedKey] = this.unsimplifyInnerMeta(metaObj[key]);
      } else {
        newMetaObj[unsimplifiedKey] = metaObj[key];
      }
    }
    return newMetaObj;
  },

  unsimplifyInnerMeta(innerMetaObj) {
    const newInnerMetaObj = {};
    for (const key in innerMetaObj) {
      const unsimplifiedKey = this.unsimplifyKey(key, this.INNER_META_MAPPING);
      newInnerMetaObj[unsimplifiedKey] = innerMetaObj[key];
    }
    return newInnerMetaObj;
  }
};